import { apiClient } from './client';
import type { Tag } from './types/shared';

export const tags = {
  async list(): Promise<Tag[]> {
    try {
      const response = await apiClient.get('/tags/');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch tags:', error);
      throw error;
    }
  }
};
